import React, { useEffect, useState, useRef, lazy } from 'react';
import { useVideo } from './VideoContext';
const portfolioData = {
  series: [{
    id: 'Epznj_VSFpQ',
    title: 'NPO Zapp - Sinterklaas Journaal Intro 2025',
    thumbnail: 'https://img.youtube.com/vi/Epznj_VSFpQ/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 's3hlipr-5YY',
    title: 'Dertigers S6 | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/s3hlipr-5YY/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'rVgYwUvqnIE',
    title: 'Sleepers seizoen 3 | Trailer | Vanaf 12 december',
    thumbnail: 'https://img.youtube.com/vi/rVgYwUvqnIE/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'dJuw6CWRcZg',
    title: 'Rundfunk: Schwalbe | BNNVARA',
    thumbnail: 'https://img.youtube.com/vi/dJuw6CWRcZg/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'MptDJUUQkkQ',
    title: 'Trailer Woeste Grond | Seizoen 3',
    thumbnail: 'https://img.youtube.com/vi/MptDJUUQkkQ/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'uBo3z53NCmA',
    title: 'Teaser: Willem van Oranje de Musical',
    thumbnail: 'https://img.youtube.com/vi/uBo3z53NCmA/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'z09f_MWGaAc',
    title: 'Tropenjaren S2 | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/z09f_MWGaAc/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'fwP6gc52qqQ',
    title: 'BODEM - TRAILER | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/fwP6gc52qqQ/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'qPht50R46Zs',
    title: 'GAAT MIJN DROOM NOG LUKKEN DOOR DE OORLOG?! #1 | Oorlog-stories 2022 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/qPht50R46Zs/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'zhHqHRYCaP4',
    title: 'Sinterklaasjournaal intro 2024',
    thumbnail: 'https://img.youtube.com/vi/zhHqHRYCaP4/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'nm9i5dvYkhI',
    title: 'Een van ons - Trailer - Nu exclusief bij CANAL+',
    thumbnail: 'https://img.youtube.com/vi/nm9i5dvYkhI/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'CUc40AM-P44',
    title: 'OPPASSEN... | Broodje Aap | #8 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/CUc40AM-P44/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }],
  videoclips: [{
    id: 'sxQ3F_-3UEc',
    title: 'FeestDJRuud - Lonely at the Tap (OFFICIAL VIDEO)',
    thumbnail: 'https://img.youtube.com/vi/sxQ3F_-3UEc/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'pZvz4X_ayQ4',
    title: 'W&W x Blasterjaxx - Let The Music Take Control',
    thumbnail: 'https://img.youtube.com/vi/pZvz4X_ayQ4/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: '161apPdhOWg',
    title: 'Gerard Joling feat. Poke – We Gaan Raket Nu',
    thumbnail: 'https://img.youtube.com/vi/161apPdhOWg/maxresdefault.jpg',
    role: 'Director',
    company: 'Blue Rain Productions'
  }, {
    id: 'LP2Helvgrqw',
    title: 'ChildsPlay & Cimo Fränkel - Always',
    thumbnail: 'https://img.youtube.com/vi/LP2Helvgrqw/maxresdefault.jpg',
    role: 'Director',
    company: 'Blue Rain Productions'
  }, {
    id: 'xqAqaLV8Nf4',
    title: 'Lucas & Steve - Up Till Dawn (On The Move)',
    thumbnail: 'https://img.youtube.com/vi/xqAqaLV8Nf4/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'eyHSH4AmlQg',
    title: 'Timmy Trumpet x Jebroer x Dr Phunk - Child Of The Devil',
    thumbnail: 'https://img.youtube.com/vi/eyHSH4AmlQg/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'miPMQ544vM0',
    title: 'W&W x Armin van Buuren – Ready To Rave',
    thumbnail: 'https://img.youtube.com/vi/miPMQ544vM0/maxresdefault.jpg',
    role: 'Cameraman',
    company: 'Blue Rain Productions'
  }],
  commercials: [{
    id: 'Ku0TR4rvYTk',
    title: 'ULTRA EUROPE 2025 - Official Aftermovie',
    thumbnail: 'https://img.youtube.com/vi/Ku0TR4rvYTk/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'JjZs8Do2HgQ',
    title: 'PAROOKAVILLE 2025 | OFFICIAL AFTERMOVIE',
    thumbnail: 'https://img.youtube.com/vi/JjZs8Do2HgQ/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: '6FbZKXoPNLU',
    title: 'Aftersocks for Charity',
    thumbnail: 'https://img.youtube.com/vi/6FbZKXoPNLU/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'tpSspYS_rj8',
    title: 'Neverland Festival Official 2018 Aftermovie',
    thumbnail: 'https://img.youtube.com/vi/tpSspYS_rj8/maxresdefault.jpg',
    role: 'Director',
    company: 'Blue Rain Productions'
  }, {
    id: 'hhJrLPzB-yk',
    title: 'Syndicate of Vigilantes - Official Trailer',
    thumbnail: 'https://img.youtube.com/vi/hhJrLPzB-yk/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }, {
    id: 'HF4SgR4wBfk',
    title: 'HOTTUB-BOAT DJ-SET - MR. BELT & WEZOL',
    thumbnail: 'https://img.youtube.com/vi/HF4SgR4wBfk/maxresdefault.jpg',
    role: 'Director',
    company: 'Blue Rain Productions'
  }, {
    id: 'VcrHnu_tiiM',
    title: 'CYCLING THROUGH THE SNOW DJ-SET - MR. BELT & WEZOL',
    thumbnail: 'https://img.youtube.com/vi/VcrHnu_tiiM/maxresdefault.jpg',
    role: 'Director',
    company: 'Blue Rain Productions'
  }, {
    id: 'Gyty_2Vu6F0',
    title: "Mixmash @ Parookaville 2018! | Rockin' With The Best Takeover Aftermovie",
    thumbnail: 'https://img.youtube.com/vi/Gyty_2Vu6F0/maxresdefault.jpg',
    role: 'Producer',
    company: 'Blue Rain Productions'
  }]
};
export const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState('series');
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const [showAll, setShowAll] = useState(false);
  const sectionRef = useRef(null);
  const {
    openVideo
  } = useVideo();
  const isMobile = window.innerWidth < 768;
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.disconnect();
      }
    };
  }, []);
  return <section id="portfolio" ref={sectionRef} className="py-24 bg-gradient-to-b from-black to-gray-950 w-full" data-id="element-280">
      <div className="container mx-auto px-4 md:px-6" data-id="element-281">
        <h2 className={`text-3xl md:text-5xl font-bold mb-6 text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-282">
          Producties
        </h2>
        <div className={`max-w-2xl mx-auto text-center mb-8 text-gray-400 text-xs md:text-sm italic transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-283">
          <p data-id="element-284">
            Hier een selectie van producties waaraan Blue Rain Productions heeft
            mogen meewerken, van producer tot en met locatiemanagement. We zijn
            trots op onze bijdrage aan het succes van deze projecten.
          </p>
        </div>
        <div className={`flex flex-wrap justify-center mb-12 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-285">
          <button onClick={() => {
          setActiveCategory('series');
          setShowAll(false);
        }} className={`px-6 py-3 mx-2 mb-4 rounded-sm transition-all ${activeCategory === 'series' ? 'bg-blue-600 text-white' : 'bg-transparent text-white border border-gray-700 hover:border-blue-400'}`} data-id="element-286">
            Series & Films
          </button>
          <button onClick={() => {
          setActiveCategory('videoclips');
          setShowAll(false);
        }} className={`px-6 py-3 mx-2 mb-4 rounded-sm transition-all ${activeCategory === 'videoclips' ? 'bg-blue-600 text-white' : 'bg-transparent text-white border border-gray-700 hover:border-blue-400'}`} data-id="element-287">
            Videoclips
          </button>
          <button onClick={() => {
          setActiveCategory('commercials');
          setShowAll(false);
        }} className={`px-6 py-3 mx-2 mb-4 rounded-sm transition-all ${activeCategory === 'commercials' ? 'bg-blue-600 text-white' : 'bg-transparent text-white border border-gray-700 hover:border-blue-400'}`} data-id="element-288">
            Commercials / Festivals / Promo
          </button>
        </div>
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-289">
          {portfolioData[activeCategory].slice(0, showAll ? portfolioData[activeCategory].length : isMobile ? 3 : 6).map(item => <div key={item.id} className="group relative overflow-hidden rounded-sm transform transition-all duration-500 hover:scale-[1.02] hover:shadow-xl cursor-pointer" onClick={() => openVideo(item.id, item.title)} onMouseEnter={() => setHoveredItem(item.id)} onMouseLeave={() => setHoveredItem(null)} data-id="element-290">
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent z-10 opacity-80 group-hover:opacity-70 transition-opacity" data-id="element-291"></div>
                <img src={item.thumbnail} alt={`${item.title} - ${item.role || ''} - Blue Rain Productions`} className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" data-id="element-292" />
                <div className={`absolute inset-0 flex items-center justify-center z-20 transition-opacity duration-300 ${hoveredItem === item.id ? 'opacity-100' : 'opacity-0'}`} data-id="element-293">
                  <div className="w-16 h-16 rounded-full bg-blue-600/80 backdrop-blur-sm flex items-center justify-center transform transition-transform duration-300 group-hover:scale-110" data-id="element-294">
                    <svg className="w-6 h-6 text-white ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-295">
                      <path d="M8 5V19L19 12L8 5Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-296" />
                    </svg>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 z-20" data-id="element-297">
                  <h3 className="text-xl font-semibold text-white group-hover:text-blue-400 transition-colors" data-id="element-298">
                    {item.title}
                  </h3>
                  <div className={`mt-3 text-sm text-blue-400 flex items-center transition-all duration-300 ${hoveredItem === item.id ? 'opacity-100' : 'opacity-0'}`} data-id="element-299">
                    Bekijk video
                    <svg className="ml-2 w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-300">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-301" />
                    </svg>
                  </div>
                </div>
              </div>)}
        </div>
        {!showAll && <div className="flex justify-center mt-10" data-id="element-302">
            <a href="/producties" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-sm transition-colors duration-300 flex items-center space-x-2" data-id="element-303">
              <span data-id="element-304">Bekijk alle producties</span>
              <svg className="ml-2 w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-305">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-306" />
              </svg>
            </a>
          </div>}
        {showAll && <div className="flex justify-center mt-10" data-id="element-307">
            <button onClick={() => {
          setShowAll(false);
          document.getElementById('portfolio')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} className="bg-transparent hover:bg-blue-600 text-white px-8 py-3 border border-white hover:border-blue-600 rounded-sm transition-colors duration-300 flex items-center space-x-2" data-id="element-308">
              <span data-id="element-309">Toon minder</span>
              <svg className="ml-2 w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-310">
                <path d="M19 15l-7-7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-311" />
              </svg>
            </button>
          </div>}
      </div>
      <div id="showreel" className="mt-24 py-24 bg-black w-full relative overflow-hidden" data-id="element-312">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-black" data-id="element-313"></div>
        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-314">
          <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-315">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-316">
              DETECTOR MASTERS
            </h2>
            <p className="text-xl text-gray-300" data-id="element-317">
              Daarnaast heeft Blue Rain Productions het programma Detector
              Masters ontwikkeld. Benieuwd naar dit project? Neem dan contact
              met ons op voor meer informatie.
            </p>
          </div>
          <div className="relative aspect-video max-w-5xl mx-auto rounded-sm overflow-hidden shadow-2xl" data-id="element-318">
            <img src="https://img.youtube.com/vi/iGb4WMx6Y3s/maxresdefault.jpg" alt="Detector Masters - Project ontwikkeld door Blue Rain Productions" className="w-full h-full object-cover" data-id="element-319" />
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center" data-id="element-320">
              <button onClick={() => openVideo('iGb4WMx6Y3s', 'Detector Masters')} className="w-24 h-24 rounded-full bg-blue-600/80 backdrop-blur-sm flex items-center justify-center transition-transform duration-300 transform hover:scale-110" data-id="element-321">
                <svg className="w-10 h-10 text-white ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-322">
                  <path d="M8 5V19L19 12L8 5Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-323" />
                </svg>
              </button>
            </div>
          </div>
          <div className="mt-24 max-w-4xl mx-auto" data-id="element-324">
            <h3 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-325">
              Lopende producties
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-326">
              <div className="bg-gradient-to-br from-blue-900/30 to-black p-6 rounded-sm border border-blue-900/50 transform transition-transform hover:scale-[1.02] hover:shadow-lg" data-id="element-327">
                <h4 className="text-xl font-semibold text-white mb-3" data-id="element-328">
                  Dertigers seizoen 7
                </h4>
                <p className="text-gray-300" data-id="element-329">
                  Blue Rain Productions is betrokken bij de productie van het
                  zevende seizoen van de populaire serie Dertigers.
                </p>
                <div className="mt-4 inline-block text-blue-400 text-sm font-medium" data-id="element-330">
                  In productie
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};